import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="brand-submission-match"
//
// Shows, as the submitter types a brand name, the approved brands we already have that it could
// be, so they find the brand instead of submitting it again. The server renders the matches into
// the frame; this controller only decides when to ask.
export default class extends Controller {
  static targets = ["name", "frame"]
  static values = { url: String, delay: { type: Number, default: 300 } }

  disconnect() {
    clearTimeout(this.timer)
  }

  refresh() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), this.delayValue)
  }

  load() {
    const name = this.nameTarget.value.trim()

    if (name.length < 3) {
      this.frameTarget.removeAttribute("src")
      this.frameTarget.innerHTML = ""
      return
    }

    const endpoint = new URL(this.urlValue, window.location.origin)
    endpoint.searchParams.set("name", name)
    this.frameTarget.src = endpoint.toString()
  }
}
